/**
 * An edit cancels every live leg first (the executor groups legs at CREATE
 * time) and then creates the new set. If that final create fails, the position
 * is left with NO TP/SL at all. That must never read like an ordinary failed
 * edit, so it gets its own error, which callers surface persistently with a way
 * to try again.
 */
export class TpslLegsRemovedError extends Error {
  readonly removedLegs: number;

  readonly reason: string;

  constructor(removedLegs: number, cause: unknown) {
    const reason = (cause as Error)?.message || "unknown error";
    super(
      `Your previous TP/SL was cancelled, but the new TP/SL could not be set, so this position has NO TP/SL now. (${reason})`
    );
    this.name = "TpslLegsRemovedError";
    this.removedLegs = removedLegs;
    this.reason = reason;
  }
}

export const isTpslLegsRemovedError = (error: unknown): error is TpslLegsRemovedError =>
  error instanceof TpslLegsRemovedError ||
  (error as Error | undefined)?.name === "TpslLegsRemovedError";
